import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/food_noimage.png'
import _imports_1 from '@/assets/images/icon_rating_fill.png'
import _imports_2 from '@/assets/images/icon_rating_empty.png'
import _imports_3 from '@/assets/images/icon_checklist_line_plus.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-4cd6d8fc")

_pushScopeId("data-v-4cd6d8fc")
const _hoisted_1 = { class: "mypagefoodlist-item" }
const _hoisted_2 = {
  key: 1,
  class: "mypagefoodlist-item-contents-image",
  src: _imports_0
}
const _hoisted_3 = { class: "mypagefoodlist-item-contents-foodname" }
const _hoisted_4 = { class: "mypagefoodlist-item-contents-foodname-text" }
const _hoisted_5 = {
  key: 0,
  class: "mypagefoodlist-item-contents-favoritemark-image",
  src: _imports_1
}
const _hoisted_6 = {
  key: 1,
  class: "mypagefoodlist-item-contents-favoritemark-image",
  src: _imports_2
}
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  class: "mypagefoodlist-item-contents-shoppinglist-image",
  src: _imports_3
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "mypagefoodlist-item-bottom" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "mypagefoodlist-item-contents",
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickItem(...args)))
    }, [
      (_ctx.foodImage)
        ? (_openBlock(), _createBlock("img", {
            key: 0,
            class: "mypagefoodlist-item-contents-image",
            src: _ctx.foodImage,
            onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onImageError(...args)))
          }, null, 40, ["src"]))
        : (_openBlock(), _createBlock("img", _hoisted_2)),
      _createVNode("div", _hoisted_3, [
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.foodName), 1)
      ]),
      _createVNode("button", {
        class: "mypagefoodlist-item-contents-favoritemark",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickFavorite(...args)))
      }, [
        (_ctx.isFavorite)
          ? (_openBlock(), _createBlock("img", _hoisted_5))
          : (_openBlock(), _createBlock("img", _hoisted_6))
      ]),
      _createVNode("button", {
        class: "mypagefoodlist-item-contents-shoppinglist",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickShoppingList(...args)))
      }, [
        _hoisted_7
      ])
    ]),
    _hoisted_8
  ]))
})